import {
    Typography,
    FormControl,
    FormControlLabel,
    FormGroup,
    Switch,
    Box,
    Chip,
} from '@mui/material';
import {
    VisibilityOutlined as VisibilityIcon,
    Notes as NotesIcon,
    AccountBalanceOutlined as SourceIcon,
    GavelOutlined as SettlementIcon,
    PaymentsOutlined as SupportIcon,
} from '@mui/icons-material';
import CollapsiblePanel from './CollapsiblePanel';

const ExportDisplayOptionsForm = ({ displayOptions, setDisplayOptions }) => {

    const handleOptionChange = (option) => (event) => {
        setDisplayOptions(prev => ({
            ...prev,
            [option]: event.target.checked
        }));
    };

    const titleElement = (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <VisibilityIcon color="primary" fontSize="small" />
            <Typography variant="subtitle1" component="h3" sx={{
                fontWeight: 600, display: 'flex',
                alignItems: 'center',
                gap: 1
            }}>
                Export Options
            </Typography>
        </Box>
    );

    return (
        <CollapsiblePanel defaultCollapsed={false} titleElement={titleElement}>
            <FormControl component="fieldset" variant="standard">
                <FormGroup sx={{ paddingLeft: '16px' }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={displayOptions.showNotes}
                                onChange={handleOptionChange('showNotes')}
                                color="primary"
                                size="small"
                            />
                        }
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <NotesIcon sx={{ fontSize: 18 }} />
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    Include Notes
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 0.2, ml: 0.2 }}>
                                    <Chip label="Notes" size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
                                </Box>
                            </Box>
                        }
                        sx={{ mb: 0.5, '& .MuiFormControlLabel-label': { marginLeft: '6px' } }}
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={displayOptions.showSourceColumns}
                                onChange={handleOptionChange('showSourceColumns')}
                                color="primary"
                                size="small"
                            />
                        }
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <SourceIcon sx={{ fontSize: 18 }} />
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    Include Source of Funds Amounts
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 0.5, ml: 0.2 }}>
                                    <Chip label="Petitioner Source" size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
                                    <Chip label="Respondent Source" size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
                                    <Chip label="Marital Source" size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
                                </Box>
                            </Box>
                        }
                        sx={{ mb: 0.5, '& .MuiFormControlLabel-label': { marginLeft: '6px' } }}
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={displayOptions.showSettlementColumns}
                                onChange={handleOptionChange('showSettlementColumns')}
                                color="primary"
                                size="small"
                            />
                        }
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <SettlementIcon sx={{ fontSize: 18 }} />
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    Include Settlement Amounts
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 0.5, ml: 0.2 }}>
                                    <Chip label="Petitioner Settlement" size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
                                    <Chip label="Respondent Settlement" size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
                                    <Chip label="Final Settlement Amount" size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
                                </Box>
                            </Box>
                        }
                        sx={{ mb: 0.5, '& .MuiFormControlLabel-label': { marginLeft: '6px' } }}
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={!!displayOptions.showSupportFields}
                                onChange={handleOptionChange('showSupportFields')}
                                color="primary"
                                size="small"
                            />
                        }
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                <SupportIcon sx={{ fontSize: 18 }} />
                                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    Include Support Fields
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 0.5, ml: 0.2 }}>
                                    <Chip label="Spousal Support" size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
                                    <Chip label="Child Support" size="small" variant="outlined" sx={{ height: 20, fontSize: '0.7rem' }} />
                                </Box>
                            </Box>
                        }
                        sx={{ mb: 0.5, '& .MuiFormControlLabel-label': { marginLeft: '6px' } }}
                    />
                </FormGroup>
            </FormControl>
        </CollapsiblePanel>
    );
};

export default ExportDisplayOptionsForm;
